import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet } from 'react-router-dom'
import { Nav, Navbar, NavItem } from 'reactstrap'
import classnames from 'classnames'

import PageHeader from '../common/PageHeader/PageHeader'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'

import classes from './CommunitySettingsPage.module.scss'
import { setCurrentTab, showNavBar, showSideBar } from '../../actions/commonActions'

const tabsData = [
  {
    tKey: 'communitySettings.page.tabs.pricing',
    path: 'pricing',
  },
  {
    tKey: 'communitySettings.page.tabs.landing',
    path: 'landing',
  },
  {
    tKey: 'communitySettings.page.tabs.accessCode',
    path: 'access-code',
  },
  {
    tKey: 'communitySettings.page.tabs.clubs',
    path: 'clubs',
  },
  {
    tKey: 'common.language',
    path: 'language',
  },
]

const CommunitySettingsPage = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const isLoadingUserRefresh = useSelector(state => state.loading.isLoading)

  useEffect(() => {
    dispatch(setCurrentTab('Community-Settings'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))
  }, [dispatch])

  if (isLoadingUserRefresh === false) {
    return (
      <div className={classnames('d-flex flex-column', classes['community-settings-page'])}>
        <PageHeader title={t('communitySettings.page.title')} />
        <Navbar className={classes.navbar}>
          <Nav className={classes.nav} tabs>
            {tabsData.map((tabData, index) => (
              <NavItem key={index} className={classes.navItem}>
                <NavLink
                  to={tabData.path}
                  className={({ isActive }) => classnames(classes.navLink, { [classes.active]: isActive })}
                >
                  {t(tabData.tKey)}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Navbar>
        <main className={classes.main}>
          <Outlet />
        </main>
      </div>
    )
  }

  return <Loader message={t('communitySettings.page.loading')} />
}

export default CommunitySettingsPage
